import React, { useEffect, useState } from "react";
import StatsSection from "../StatItem/StatItem";
import { mapWithFallback } from "../../../lib/utils";
import TeamIcon from "../../../assets/imgs/team-icon.svg";
import TargetIcon from "../../../assets/imgs/target-arrow.svg";
import GameScriptIcon from "../../../assets/imgs/game-script-icon.svg";
import RecentTrendIcon from "../../../assets/imgs/recent-trend-icon.svg";
import PlusIcon from "../../../assets/imgs/big-plus.svg";
import MinusIcon from "../../../assets/imgs/big-minus.svg";
import { useNavigate } from "react-router-dom";
import TableTabs from "../../Commons/TableTabs/TableTabs";
import FeaturePlayersCard from "../../Home/FeaturePlayersCard/FeaturePlayersCard";
import SeasonPreview from "../../../assets/imgs/season_preview.png";
import DraftRange from "../../Commons/DraftRange/DraftRange";

interface Props {
  player: any;
  handlePerfomanceModal?: any;
  showSimilarPlayers?: boolean;
  setSimilarPlayerId?: (id: string | null) => void;
}

const categoriesFilters = [
  { id: 1, name: "ALL" },
  { id: 2, name: "L3" },
  { id: 3, name: "L5" },
  { id: 4, name: "L7" },
];

const stats = [
  {
    icon: <img src={TargetIcon} alt="" className="text-white w-[18px]" />,
    title: "Defense vs. Position",
    description: "Ravens allow 15.5 ppg to RBs (7th most)",
    actionIcon: <img src={PlusIcon} alt="" className="w-4" />,
  },
  {
    icon: <img src={GameScriptIcon} alt="" className="text-white" />,
    title: "Game Script",
    description: "Game Total: 49.5. Detroit (+7.5)",
    actionIcon: <img src={MinusIcon} alt="" className="" />,
  },
  {
    icon: <img src={RecentTrendIcon} alt="" className="text-white" />,
    title: "Recent Trend",
    description: "Gibbs averaging 15.3 FPPG in L3 games",
    actionIcon: null, // No action icon for this one
  },
];

const PlayerScores = ({
  player,
  handlePerfomanceModal,
  showSimilarPlayers,
  setSimilarPlayerId,
}: Props) => {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedCardData, setSelectedCarddata] = useState([] as any);
  const [playerPosition, setplayerPosition] = useState<any>({
    id: 1,
    name: "ALL",
  });

  console.log("player", player);
  useEffect(() => {
    if (player?.statBars) {
      const key =
        playerPosition.name === "ALL" ? "seasonal" : playerPosition.name;
      const filterData = player?.statBars[0][key]?.statCategories || [];

      setSelectedCarddata(filterData);
    }
  }, [player, playerPosition]);

  const getProgressColor = (score?: number) => {
    if (score === undefined) return "";
    if (score > 85) return "#16C265";
    if (score > 75) return "#DBFF00";
    return "#F11E84";
  };
  const playerPerformanceScoresType =
    typeof player?.playerPerformanceScores?.performanceCards[0]
      ?.weeklyPerformanceScores;

  const weeklyPerformanceScores =
    playerPerformanceScoresType === "string"
      ? JSON.parse(
          player?.playerPerformanceScores?.performanceCards[0]
            ?.weeklyPerformanceScores,
        ) || {}
      : player?.playerPerformanceScores?.performanceCards[0]
          ?.weeklyPerformanceScores || {};

  const handleSelect = (item: any) => {
    setplayerPosition(item);
  };

  const handlePlayerClick = async (playerId: string) => {
    if (setSimilarPlayerId) {
      setSimilarPlayerId(playerId);
    }
  };

  console.log("player", player);

  return (
    <div className="mt-10">
      <div>
        <div className="flex items-center gap-[14px]">
          <img
            src={SeasonPreview}
            alt={SeasonPreview}
            className="w-[40px] h-[40px]"
          />
          <div className="flex flex-col gap-[4px] ">
            <p className="text-white text-[14px] font-semibold">
              Season Preview
            </p>
            <p className="text-white/50 text-[10px] font-normal">
              Draft Projections for 2025
            </p>
          </div>
        </div>
        <div className="mt-8 flex ">
          <div className="flex-col space-y-[8px] ">
            <p className="text-white text-[16px] font-bold">{(player?.draftOverview?.consensus_ADP || 0).toFixed(1)}</p>
            <p className="text-white/50 text-[10px] font-normal">
              Average Draft Position
            </p>
          </div>

          <div className="w-[1px] bg-white/20  [@media(min-width:375px)]:mx-[36px] mx-[28px]"></div>

          <div className="flex-col space-y-[8px] ">
            <p className="text-white text-[16px] font-bold">{player?.draftOverview?.rotobot_take || "-"}</p>
            <p className="text-white/50 text-[10px] font-normal">
              RotoBots Take
            </p>
          </div>
        </div>
        <div className="mt-8 flex flex-col space-y-[8px]">
          <p className="text-[14px] text-white font-semibold">
            Expected Draft Range
          </p>
          <p className="text-[10px] text-white/50 font-normal">
            Where RotoBot expects him to be drafted
          </p>
        </div>

        <div className="mt-5">
          <DraftRange
            leftValue={player?.draftOverview?.reach_bound || 0}
            rightValue={player?.draftOverview?.steal_bound || 100}
            leftLabel="Reach"
            rightLabel="Steal"
          />
        </div>
      </div>

      <div className="mt-[72px]">
        <TableTabs
          tabItems={categoriesFilters}
          tabCustomStyle="h-[27.8px] rounded-[25.38px] text-[11.28px] min-w-[63.22px] shrink-0 p-[0px] font-medium"
          onTabSelect={handleSelect}
          InicialselectedTab={playerPosition}
          selectedTabColor="#08262A"
          unSelectTabColor="#1C1C1A"
          selectedTabStyle="!text-[#00E0FF]"
        />
      </div>
      <div className="mt-6 grid lg:grid-cols-2 lg:gap-x-10 md:gap-x-5">
        {mapWithFallback(selectedCardData).map(
          (category: any, index: number) => (
            <StatsSection key={index} {...category} />
          ),
        )}
      </div>

      {showSimilarPlayers && (
        <div className="mt-7 pb-5">
          <div className="flex items-center text-white mb-4 sm:mb-5 md:mb-6 lg:mb-7">
            <img src={TeamIcon} alt="TeamIcon" className="w-5" />
            <h3 className="text-base sm:text-3xl md:text-4xl lg:text-[45.393px] font-semibold ml-2">
              Similar Players
            </h3>
          </div>

          {(!player?.similarPlayers || player?.similarPlayers?.length === 0) ? (
            <div className="text-[22px] text-white/50 font-medium flex justify-center py-4">
              -- No Data --
            </div>
          ) : (
            player?.similarPlayers?.map((player: any, index: number) => (
              <div
                className={`flex flex-col gap-4 -ml-3 ${index !== player?.similarPlayers?.length - 1 && "border-b-[0.6px]"} border-[#ffffff33]`}
                key={index}
                onClick={() => {
                  handlePlayerClick(player?.roto_player_id);
                }}
              >
                <FeaturePlayersCard
                  playerSmallIcon={player.player_headshot_url}
                  playerName={player.name}
                  playerPosition={player.orig_position}
                  playerStatus={player.player_team}
                  bgColor={player.player_team_short}
                  cardBg={false}
                />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default PlayerScores;
